<script>
import { mapActions, mapState } from 'vuex'

import ProgressBar from './progress-bar.vue'

export default {
  components: {
    ProgressBar,
  },

  data () {
    return {
      is_saving: false,
      save_name: null,
    }
  },

  props: [
    'is_small'
  ],

  methods: {
    ...mapActions([
      'getReservationSaves',
      'postReservationSave'
    ]),

    showModal: function (event) {
      this.getReservationSaves()
      this.save_name = null

      $('[data-toggle="tooltip"]').blur()
      $('#reservationSaveModal').modal('show')
    },

    saveLab: function (event) {
      if(this.is_saving) {
        return
      }
      this.is_saving = true

      let payload = {
        json: {
          'save_name': this.save_name
        },
        self: this,
      }

      this.postReservationSave(payload)
    },
  },

  computed: {
    ...mapState({
      reservation_transaction: state =>
        state.reservation.reservation_transactions.find(
          t => t.id === state.reservation.current.id
        ),
      reservation_saves: state =>
        state.reservation.reservation_saves,
      infrastructure_pod: state => {
        let transaction = state.reservation.reservation_transactions.find(
          t => t.id === state.reservation.current.id
        )
        return state.infrastructure.infrastructure_pods.find(
          p => p.id === transaction.relationships.infrastructure_pod.data.id
        )
      }
    }),

    userSavesTotal: function () {
      return this.reservation_saves.length;
    },

    saveExpires: function () {
      return Labstack.save_expires;
    },

    saveLimit: function () {
      return Labstack.save_limit;
    },

    isDisabled: function () {
      return this.is_saving ||
      (
        this.reservation_transaction &&
        // Pending status
        this.infrastructure_pod.attributes.pod_status == 2
      )
    }
  }
}
</script>

<template>
  <div>
    <a class="btn btn-success btn-block click-prevent" @click.prevent="showModal" :class="{ 'disabled': isDisabled, 'btn-sm': is_small }">
      <i class="fa fa-bolt"></i>&nbsp;&nbsp;
      Save &amp; Terminate
    </a>
    <div class="modal fade" id="reservationSaveModal" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content text-left">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">
              Save &amp; Terminate Reservation&nbsp;&nbsp;<span class="label label-info">BETA</span>
            </h4>
          </div>
          <div class="modal-body">
            <div class="alert alert-info" v-if="userSavesTotal < saveLimit">
            You can save your work and come back later. Please note, saved reservations default to expire
            {{ saveExpires }} days from now.
            </div>

            <div class="alert alert-danger" v-if="userSavesTotal >= saveLimit">
            You are limited to creating {{ saveLimit }} saves at the present time. You may want to delete some
            of your older saves.
            </div>

            <div class="row" style="padding-bottom: 1.5em">
              <div class="col-md-8">
                <progress-bar
                  :value="userSavesTotal"
                  :max_value="saveLimit"
                  :percentage="false">
                </progress-bar>
              </div>
              <div class="col-md-4">
                <a class="btn btn-default btn-block" href="/saves">
                  <i class="fa fa-floppy-o"></i>&nbsp;&nbsp;Manage Saves
                </a>
              </div>
            </div>

            <div class="form-group">
              <label for="save_name" class="control-label">Save name</label>
              <input type="text" class="form-control" name="save_name" required placeholder="Save name" v-model="save_name">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button"
              class="btn btn-primary"
              :class="{ 'disabled' : isDisabled || ! save_name || userSavesTotal >= saveLimit }"
              @click.prevent="saveLab"
            >Save &amp; Terminate</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
